import React, { FC } from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';

import styles from './button.module.scss';

interface IProps {
  isFixedWidth?: boolean;
  isDisabled?: boolean;
  isHoverDisabled?: boolean;
  appearance?: 'default' | 'light' | 'blank';
  size?: 'default' | 'compact' | ''
  link?: string;
  className?: string;
  onClick?: () => void;
}

const Button: FC<IProps> = ({
  isFixedWidth,
  isDisabled,
  isHoverDisabled,
  appearance,
  size,
  link,
  className: extClassName,
  children,
  onClick,
}) => {
  const className = cx(
    styles.button,
    {
      [styles.buttonLight]: appearance === 'light',
      [styles.buttonBlank]: appearance === 'blank',
      [styles.buttonCompact]: size === 'compact',
      [styles.buttonFixedWidth]: isFixedWidth,
      [styles.hoverDisabled]: isHoverDisabled || isDisabled,
    },
    extClassName,
  );

  if (link) {
    return (
      <Link
        className={className}
        to={link}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      type="button"
      disabled={isDisabled}
      className={className}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
